'use client'

import { NumberFlow } from '@ui/web/components'
import cn from '@config/tailwind/cn'

interface AnimatedCurrencyProps {
  value: number
  /** Typography and colour. Pass `typographyVariants(...)` first, as everywhere else. */
  className?: string
}

/**
 * A rupiah figure that rolls to its new value instead of cutting to it.
 *
 * `prefix='Rp'` with a plain decimal format rather than `style: 'currency'`: id-ID renders IDR as
 * "Rp 26.650" with a non-breaking space, while `formatCurrency` strips it. Going through the prefix
 * keeps the animated figures character-for-character identical to the static ones beside them.
 *
 * The digit grouping matches `formatCurrency`'s defaults — no forced decimals, at most two.
 *
 * `className` REPLACES `NumberFlow`'s own defaults rather than merging with them: that component
 * ships `ui:`-prefixed sizing, which cannot be overridden from a `srd:`-prefixed package because
 * tailwind-merge treats the two prefixes as unrelated classes. Its props spread last, so passing
 * `className` wins outright — which is exactly what is wanted here.
 */
export function AnimatedCurrency({ value, className }: AnimatedCurrencyProps) {
  return (
    <NumberFlow
      value={value}
      prefix='Rp'
      format={{ minimumFractionDigits: 0, maximumFractionDigits: 2 }}
      className={cn(className)}
    />
  )
}
